import { IRestaurant } from "../models/IRestaurant";
import { S3_IMAGE_BASE_URL } from "../config/restaurantConfig";

interface Props {
  restaurant: IRestaurant | null;
}

export default function Hero({ restaurant }: Props) {
  const bgImage = restaurant?.restourantFeatureadImagePath
    ? S3_IMAGE_BASE_URL + restaurant.restourantFeatureadImagePath
    : undefined;

  return (
    <section
      id="top"
      className="rr-hero"
      style={bgImage ? { backgroundImage: `url(${bgImage})` } : undefined}
    >
      <div className="rr-hero-content">
        <h1>{restaurant?.restourantName ?? "Restoran"}</h1>
        <p>Lezzet dolu bir deneyim için sizi bekliyoruz</p>
        <a
          href="#rezervasyon"
          className="rr-btn-gold"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById("rezervasyon")?.scrollIntoView({ behavior: "smooth" });
          }}
        >
          <i className="bi bi-calendar-check"></i> Rezervasyon Yap
        </a>
      </div>
    </section>
  );
}
